import { useEffect, useState, FC } from 'react'
import BaseMedia from 'react-media'

/**
 * Hydration-safe replacement for `react-media`'s `<Media>` component.
 *
 * `react-media` reads `window.matchMedia` synchronously, so on the
 * server it always returns no match (window is polyfilled with no
 * matchMedia) while on the client it returns whatever the viewport
 * is. Under React 18 that mismatch is a hard hydration failure
 * (#418/#425).
 *
 * This wrapper defers the underlying `<Media>` by one tick so the
 * server's null output and the first client render line up; the
 * actual media query runs after `useEffect`, then React renders the
 * matched content.
 */
// Use a permissive prop type — `react-media`'s type definition treats
// `query` and `queries` as mutually-exclusive overloads in a way that
// TypeScript can't infer through this wrapper. Callers pass the same
// shape they would to BaseMedia directly.
const Media: FC<any> = (props) => {
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => setHydrated(true), [])
  if (!hydrated) return null
  return <BaseMedia {...props} />
}

export default Media
